import * as types from './types'
import storage from '@/Plugins/storage'
import moment from 'moment'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.RESET_FEED](state) {
    state.feed = []
  },
  [types.RESET_FEED_POST](state, data) {
    if (data.feedPost) {
      state.feedPost = data.feedPost
    } else {
      state.feedPost = JSON.parse(JSON.stringify(state.defaultFeedPost))
      state.feedPost.sender_id = data.userId
      state.feedPost.organization_id = data.orgId
    }
  },
  [types.RESET_COMMENT](state, data) {
    if (data.comment) {
      state.comment = data.comment
    } else {
      state.comment = JSON.parse(JSON.stringify(state.defaultComment))
      state.comment.sender_id = data.userId
      state.comment.organization_id = data.orgId
      state.comment.feed_id = data.feedId
    }
  },
  [types.SET_FEED](state, data) {
    state.feed = []
    if (data !== undefined && data !== null) {
      state.feed = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Feed', state.feed)
  },
  [types.SET_FEED_POST](state, data) {
    state.feedPost = null
    if (data !== undefined && data !== null) {
      state.feedPost = data
    }
    console.log('Got Feed Post', state.feedPost)
  },
  [types.SET_FEED_POST_LIKE](state, data) {
    console.log('Updating Feed Post Like', {
      data: data,
      feed: state.feed,
    })
    let found = state.feed.find(
      (x) => parseInt(x.id) === parseInt(data.data.message.id)
    )
    if (found) {
      console.log('Feed Post Like Found', found)
      if (data.like === 'true') {
        found.likes.push(data.data)
      } else {
        found.likes = found.likes.filter(
          (x) => parseInt(x.id) !== parseInt(data.data.id)
        )
      }
    }
  },
  [types.SET_FEED_POST_DATA](state, data) {
    switch (data.name) {
      case 'orgId': {
        state.feedPost.organization_id = data.value
        break
      }
      case 'challengeId': {
        state.feedPost.challenge_id = data.value
        break
      }
      case 'senderId': {
        state.feedPost.sender_id = data.value
        break
      }
      case 'text': {
        state.feedPost.text = data.value
        break
      }
      case 'images': {
        if (state.feedPost.images === null) {
          state.feedPost.images = []
        }
        state.feedPost.images.push(data.value)
        break
      }
      case 'deleteImages': {
        state.feedPost.delete_images = data.value
        break
      }
      case 'addImages': {
        state.feedPost.add_images = data.value
        break
      }
    }
  },
  [types.SET_COMMENT_DATA](state, data) {
    switch (data.name) {
      case 'orgId': {
        state.comment.organization_id = data.value
        break
      }
      case 'senderId':
        {
          state.comment.sender_id = data.value
          break
        }
        feed_id
      case 'text': {
        state.comment.text = data.value
        break
      }
    }
  },
  [types.SET_COMMENT](state, data) {
    console.log('Updating Comment', {
      data: data,
      feed: state.feed,
    })
    let found = state.feed.find(
      (x) => parseInt(x.id) === parseInt(data.data.message_id)
    )
    if (found) {
      if (data.action === 3) {
        console.log('Delete Comment in SET_COMMENT', found)
        let foundComment = found.comments.find(
          (x) => parseInt(x.id) === parseInt(data.id)
        )
        if (foundComment) {
          found.comments = found.comments.filter(
            (x) => parseInt(x.id) !== parseInt(data.id)
          )
        }
      } else if (data.action === 2) {
        console.log('Update Comment in SET_COMMENT', found)
        let foundComment = found.comments.find(
          (x) => parseInt(x.id) === parseInt(data.id)
        )
        if (foundComment) {
          foundComment.text = data.data.text
        }
      } else {
        console.log('Add Comment in SET_COMMENT', found)
        found.comments.push(data.data)
      }
    }
  },
}
